/* eslint-disable max-len */
import { ClassifiedAnalytics } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedAnalytics';

type ProgramCodes = 'BASE' | 'STATE_PROGRAM_2020' | 'FAMILY' | 'IT_MORTGAGE' | 'FAR_EAST';

export interface IMortgageProgram {
    mortgageProgramCodes: ProgramCodes;
    name: string;
    mobileName: string;
    mortgagePercent: string;
    label?: string[];
    infoDesk?: string[];
    infoMob?: string[];
}

export type IMortgagePrograms = Array<IMortgageProgram>

export const MAX_MORTGAGE_DISCOUNT = 0.3;

export const VTB_ID = '3';

export const VTB_BENEFITS = [ 'Быстрое рассмотрение', 'скидка на ставку с М2' ];

export const MORTGAGE_PROGRAMS: IMortgagePrograms = [
    // {
    //     mortgageProgramCodes: 'STATE_PROGRAM_2020',
    //     name: 'Господдержка',
    //     mobileName: 'Господдержка от 8%',
    //     mortgagePercent: 'от 8%',
    //     label: [ 'Выгодно' ],
    //     infoDesk: [
    //         'Господдержка\u00A0-\u00A0подходит любому совершеннолетнему гражданину\u00A0РФ.',
    //         'Первый взнос от\u00A030%, кредит до\u00A06\u00A0млн\u00A0₽'
    //     ]
    // },
    {
        mortgageProgramCodes: 'BASE',
        name: 'Стандартная',
        mobileName: 'Стандартная от 12%',
        mortgagePercent: 'от 12%',
        infoDesk: [
            'Первый взнос от\u00A010%, кредит до\u00A0100\u00A0млн\u00A0₽'
        ]
    },
    {
        mortgageProgramCodes: 'FAMILY',
        name: 'Семейная',
        mobileName: 'Семейная от 5%',
        mortgagePercent: 'от 5%',
        infoDesk: [
            'Семейная\u00A0-\u00A0Подходит семьям с\u00A0ребёнком, который родился после 1\u00A0января 2018\u00A0года, с\u00A0двумя и\u00A0более детьми младше 18\u00A0лет или\u00A0с\u00A0ребёнком с\u00A0инвалидностью.',
            'Первый взнос от\u00A020%, кредит до\u00A012\u00A0млн\u00A0₽'
        ]
    },
    {
        mortgageProgramCodes: 'IT_MORTGAGE',
        name: 'IT-ипотека',
        mobileName: 'IT-ипотека от 4%',
        mortgagePercent: 'от 4%',
        infoDesk: [
            'Подходит сотрудникам аккредитованных IT-компаний от\u00A018\u00A0до\u00A050\u00A0лет включительно, со\u00A0стажем работы от\u00A03-х месяцев.',
            'Первый взнос от\u00A020%, кредит до\u00A018\u00A0млн\u00A0₽'
        ]
    },
    // {
    //     mortgageProgramCodes: 'FAR_EAST',
    //     name: 'Дальневосточная',
    //     mortgagePercent: 'от 2%',
    //     infoDesk: [
    //         'Подходит сотрудникам аккредитованных IT-компаний от\u00A018\u00A0до\u00A050\u00A0лет включительно, со\u00A0стажем работы от\u00A03-х месяцев.',
    //         'Для молодых семей, участников программы «Дальневосточный гектар», работников ОПК, медицинской и\u00A0образовательной сфер, а\u00A0также переехавших в\u00A0ДФО из\u00A0зоны проведения спецоперации',
    //         'Первый взнос от\u00A020%, кредит до\u00A09\u00A0млн\u00A0₽'
    //     ]
    // }
];

/* Аналитика */
export const gtmShowMoreClick = 'classified_card_sale_view_ipoteka_call_back';
export const gtmCommonClick = ClassifiedAnalytics.IpotekaFromOffer;
export const gtmSendClick = 'classified_card_sale_view_ipoteka_banks';
